const props = {
    tableHeader:{
        type:Array,
        default: function () {
            return []
        }
    },
    tableData:{
        type:Array,
        default: function () {
            return []
        }
    },
    indexs:{
        type:Boolean,
        default:true
    },
    selection:{
        type:Boolean,
        default:true
    },
    loading: { // 加载等待
        type: Boolean,
        default: false
    },
    delkey:{
        type:String,
        default:"id"
    },
    selectEnable:{
        type: Function,
        default: function () {}
    }
}

export default props